import { hasWhatsAppMessages, isWhatsAppOrigin } from '@/lib/conversationChannel'
import type { Conversation } from '@/types/conversation'

export type ChannelConversation = Pick<Conversation, 'twilio_id' | 'meta'>

export function getInboxChannelLabelKey(conversation: ChannelConversation): string {
  const phone = !isWhatsAppOrigin(conversation)
  const whatsapp = hasWhatsAppMessages(conversation)
  if (phone && whatsapp) return 'resources.conversations.inbox.channels.both'
  return phone
    ? 'resources.conversations.inbox.channels.phone'
    : 'resources.conversations.inbox.channels.whatsapp'
}
